// extracted by mini-css-extract-plugin
export default {"wrap":"ToggleChips_wrap__PJyWO","label":"ToggleChips_label__s75jv","chips":"ToggleChips_chips__UDP-I"};